import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Box, Paper, IconButton, TextField } from '@mui/material';
import { VolumeUp, Delete } from '@mui/icons-material';

const AudioComponent = (props: any) => {
  const { node, updateAttributes, deleteNode } = props;
  const { url } = node.attrs;

  return (
    <NodeViewWrapper>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          my: 2,
          backgroundColor: '#f5f5f5',
          border: '2px solid #2196f3',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <VolumeUp color="primary" />
          <strong>Аудио блок</strong>
          <IconButton
            size="small"
            color="error"
            onClick={deleteNode}
            sx={{ ml: 'auto' }}
          >
            <Delete />
          </IconButton>
        </Box>
        <TextField
          fullWidth
          size="small"
          label="URL аудио"
          value={url || ''}
          onChange={(e) => updateAttributes({ url: e.target.value })}
          sx={{ mb: 1 }}
        />
        {url && (
          <audio controls style={{ width: '100%' }}>
            <source src={url} />
          </audio>
        )}
      </Paper>
    </NodeViewWrapper>
  );
};

export const AudioBlock = Node.create({
  name: 'audioBlock',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      url: { default: '' },
      is_blur: { default: true },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="audioBlock"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ 'data-type': 'audioBlock' }, HTMLAttributes),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AudioComponent);
  },

  // @ts-ignore - Tiptap type issue with custom commands
  addCommands() {
    return {
      insertAudioBlock:
        (attrs: { url?: string; is_blur?: boolean }) =>
        ({ commands }: any) =>
          commands.insertContent({
            type: this.name,
            attrs,
          }),
    };
  },
});
